import { useCookie } from '#imports';
import { useOrganizationStore } from '~/store/organization';
import { resolveDefaultLandingUrl } from '~/composables/use-default-landing-url';

export const useSocialRedirectUrl = () => {
  const { organization } = storeToRefs(useOrganizationStore());
  const socialRedirectUrl = useCookie('ex-social-redirect-url', {
    default: () => resolveDefaultLandingUrl(organization.value),
  });

  const updateSocialRedirectUrl = () => {
    socialRedirectUrl.value = globalThis.location.href;
  };

  return { socialRedirectUrl, updateSocialRedirectUrl };
};
